// extracted by mini-css-extract-plugin
export default {"DownloadAppBG":"styles_DownloadAppBG__iF22f","EvolveIcon":"styles_EvolveIcon__Tob98","Title":"styles_Title__5KFlU","SubTitle":"styles_SubTitle__IgRTz"};